import { useEffect, useRef, useState } from 'react';

export function useResizeObserver<E extends Element = Element>() {
    const [elementRef, setElementRef] = useState<E | null>(null);
    const [size, setSize] = useState<DOMRect | undefined>(undefined);
    const resizeObserver = useRef(new window.ResizeObserver(handleResize));

    useEffect(() => {
        const observer = resizeObserver.current;
        const element = elementRef;

        if (element !== null) {
            observer.observe(element);
        }

        return () => {
            if (element !== null) {
                observer.unobserve(element);
            }
        };
    }, [elementRef]);

    function handleResize(elements: ResizeObserverEntry[]) {
        const element = elements[0];
        setSize(element.target.getBoundingClientRect());
    }

    return { ref: setElementRef, size };
}
